import React, { useContext, useEffect, useState } from "react";
import AdminNav from "../Navbars/AdminNav";
import StudentNav from "../Navbars/StudentNav";
import GuestNav from "../Navbars/GuestNav";
import Footer from "../Footer";
import { UserContext } from "../UserContext";
import TeacherNav from "../Navbars/TeacherNav";
import "./MyProgress.css";
import { useNavigate, useLocation } from "react-router-dom";
import pic1 from "../CourseImages/progress.png";
import certificateIcon from "../../assets/Student dashboard/Clip path group.png";
import activitiesIcon from "../../assets/Student dashboard/Group.png";
import remarksIcon from "../../assets/Student dashboard/Group 1686552592.png";
import projectIcon from "../../assets/Student dashboard/Group-1.png";
import pointsIcon from "../../assets/Student dashboard/Clip path group-1.png";
import axios from "axios";
import { Bell } from "lucide-react";
import Header from "../Header"

const StudentProgress = () => {
  const location = useLocation();
  const studentName = location.state?.studentName;
  const selectedStudentId = location?.state?.studentId;
  const [coursesList, setCoursesList] = useState([]);
  const [studentCoursesList, setStudentCoursesList] = useState([]);
  const [teacherId, setTeacherId] = useState("");
  const {
    isAdmin,
    isTeacher,
    isStudent,
    isGuest,
    setUserRole,
    setUserInfo,
    userInfo,
  } = useContext(UserContext);

  const [studentId, setStudentId] = useState("");
  const [pdfUrl, setPdfUrl] = useState(null);
  const [averageMarksObtainedPercentage, setAverageMarksObtainedPercentage] = useState(null);
  const [averageProjectScorePercentage, setAverageProjectScorePercentage] = useState([]);
  const [totalPointsEarned, setTotalPointsEarned] = useState([]);
  const [notificationCount] = useState(3);

  const fullName = userInfo?.firstname && userInfo?.lastname
    ? `${userInfo.firstname} ${userInfo.lastname}`
    : userInfo?.username;
  const avatarInitials = userInfo?.firstname && userInfo?.lastname
    ? `${userInfo.firstname.charAt(0)}${userInfo.lastname.charAt(0)}`
    : userInfo?.username?.charAt(0)?.toUpperCase();
  const avatar = userInfo?.avatar;
  const navigate = useNavigate();

  async function teacherIdFunction(User_id) {
    return await fetch(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/teacherFromId/${User_id}`)
      .then((res) => res.json())
      .then((data) => {
        console.log("res teacher id", data);
        setTeacherId(data?.teacher_id);
        if (selectedStudentId && data?.teacher_id) {
          axios.get(
            `${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/getCoursesByteacherId/${selectedStudentId}/${data?.teacher_id}`
          ).then((res) => {
            console.log("setCoursesList : ", res?.data?.Courses);
            setCoursesList(res?.data?.Courses || []);
          }).catch((err) => console.log("Error fetching courses:", err));
        }
      })
      .catch((err) => console.log("Error fetching teacher ID:", err));
  }

  useEffect(() => {
    const fetchData = async () => {
      await fetch(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}`, {
        credentials: "include",
      }).then((response) => {
        console.log("Response:", response);
        response
          .json()
          .then((userInfo) => {
            console.log("userinfo:", userInfo);
            setUserInfo(userInfo);

            if (userInfo?.usertype) {
              const uType = userInfo?.usertype;
              setUserRole(uType);
            }
            const user_id = userInfo.User_id;
            console.log("UserID: ", user_id);
            teacherIdFunction(user_id);
            getStudentIdFromUser(user_id);
          })
          .catch((err) => console.log("Error in useeffect:", err));
      });
    };

    const getStudentIdFromUser = async (user_id) => {
      console.log("User id received is: ", user_id);
      const targetId = selectedStudentId || user_id;
      const endpoint = selectedStudentId
        ? `${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/getStudentIdWithCourses/${selectedStudentId}?type=student_id` // Hypothetical support for student_id lookup if needed, but for now we rely on the UserID lookup fix
        : `${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/getStudentIdWithCourses/${user_id}`;

      // Note: Backend endpoint /getStudentIdWithCourses now expects a UserID due to recent fix.
      // If selectedStudentId is actually a StudentID, this might fail unless we adjust backend or logic.
      // But assuming for Student Portal view, we pass user_id.

      try {
        const response = await axios.get(endpoint);
        if (response?.data.success) {
          // We set a 'default' student ID (maybe the first one) but we rely on course selection to refine it
          setStudentId(response?.data.Student_id);
          setStudentCoursesList(response?.data.Courses);
          console.log("Student courses list: ", response?.data.Courses);
        } else {
          console.error("No student found for user_id:", response?.data.Message);
          setStudentId(null);
        }
      } catch (error) {
        console.error('Error fetching student ID:', error);
        setStudentId(null);
      }
    };

    fetchData();
  }, [isAdmin, isTeacher, isStudent, isGuest]);

  const determineUserRole = (usertype) => {
    console.log("In home.js:", usertype);
    if (usertype === "Student") return "Student";
    else if (usertype === "Teacher") return "Teacher";
    else if (usertype === "Admin") return "Admin";
    else return "guest";
  };

  const onLogin = (usertype) => {
    const userRole = determineUserRole(usertype);
    setUserRole(userRole);
  };

  async function onLogout() {
    console.log("inside Onlogout.");
    await fetch(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/logout`, {
      credentials: "include",
      method: "POST",
    });
    setUserInfo(null);
    setUserRole("guest");
    navigate("/");
  }

  const calculateAverageScoreActivities = async (courseId, studentId) => {
    try {
      if (!courseId || !studentId) {
        console.log("Missing courseId or studentId for activities calculation");
        return;
      }
      const response = await axios.get(
        `${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/getActivitiesAverageMarksObtained/${courseId}/${studentId}`
      );
      const _averageMarksObtainedPercentage = response?.data.ActivitiesMetrics[0].AverageMarksPercentage;
      console.log("Average Marks Obtained Percentage: ", _averageMarksObtainedPercentage);
      setAverageMarksObtainedPercentage(Math.round(_averageMarksObtainedPercentage));
    } catch (error) {
      console.log(error);
    }
  };

  const calculateAverageScoreProject = async (courseId, studentId) => {
    try {
      if (!courseId || !studentId) {
        console.log("Missing courseId or studentId for project calculation");
        return;
      }
      const response = await axios.get(
        `${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/getAverageProjectScore/${courseId}/${studentId}`
      );
      const combinedAverageMarksPercentage = response?.data.CombinedAverageMarksPercentage;
      console.log("Average Project Score: ", combinedAverageMarksPercentage);
      setAverageProjectScorePercentage(combinedAverageMarksPercentage);
    } catch (error) {
      console.log(error);
    }
  };

  const calculatePointsEarned = async (courseId, studentId) => {
    try {
      if (!courseId || !studentId) {
        console.log("Missing courseId or studentId for points calculation");
        return;
      }
      const response = await axios.get(
        `${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/courseMarks/${courseId}/${studentId}`
      );
      console.log("response: ", response?.data);
      setTotalPointsEarned(response?.data.TotalMarks - (response?.data.TotalMarks * 0.7));
    } catch (error) {
      console.log(error);
    }
  };

  const handlePDF = async (courseId, studentId) => {
    try {
      if (!courseId || !studentId) {
        console.log("Missing courseId or studentId for PDF fetch");
        return;
      }
      const response = await axios.get(
        `${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/getCertificateFile/${studentId}/${courseId}`
      );
      const pdfFileName = response?.data.CertificateFile;
      console.log("PDF Certificate.......: ", pdfFileName);

      if (pdfFileName) {
        let pdfUrlValue;
        if (pdfFileName.startsWith("//s3.amazonaws.com")) {
          pdfUrlValue = pdfFileName;
        } else {
          const pdfResponse = await axios.get(
            `${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/getCertificate/${pdfFileName}`,
            { responseType: "blob" }
          );
          pdfUrlValue = URL.createObjectURL(pdfResponse?.data);
        }
        setPdfUrl(pdfUrlValue);
      } else {
        setPdfUrl(null);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getRemarks = (courseId, studentId) => {
    // Placeholder for remarks logic
  };

  const [selectedCourse, setSelectedCourse] = useState("");

  // Filter courses to show only those that are in both coursesList and studentCoursesList
  const filteredCourses = coursesList.filter(course =>
    studentCoursesList.some(studentCourse => studentCourse.Course_id === course.Course_id)
  );

  console.log("Filtered courses: ", filteredCourses);
  console.log("Student courses list: ", studentCoursesList);
  console.log("Courses list: ", coursesList);

  useEffect(() => {
    if (filteredCourses.length > 0 && selectedStudentId) {
      const initialCourse = filteredCourses[0]?.Course_id;
      // setSelectedCourse(initialCourse);
      calculateAverageScoreActivities(initialCourse, selectedStudentId);
      calculateAverageScoreProject(initialCourse, selectedStudentId);
      calculatePointsEarned(initialCourse, selectedStudentId);
      handlePDF(initialCourse, selectedStudentId);
    } else if (filteredCourses.length === 0) {
      console.log("No courses available for the student");
    }
  }, [filteredCourses, selectedStudentId]);

  const handleCourseChange = (event) => {
    const selectedValue = parseInt(event.target.value);
    console.log("selectedValue: ", selectedValue);
    setSelectedCourse(selectedValue);

    // Find the correct Student_id for this course
    const relevantCourse = studentCoursesList.find(c => c.Course_id === selectedValue);
    const relevantStudentId = relevantCourse ? relevantCourse.student_id : (studentId || selectedStudentId);

    console.log("Relevant Student ID for course:", relevantStudentId);

    if (relevantStudentId) {
      axios.get(
        `${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/getCertificate/${relevantStudentId}/${selectedValue}`
      ).then((res) => {
        console.log("Certificate response: ", res?.data);
        setPdfUrl(res?.data);
      }).catch((error) => console.log("Error fetching certificate:", error));

      axios.get(
        `${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/students_course_marks/${relevantStudentId}/${selectedValue}`
      ).then((res) => {
        const total = res?.data?.total;
        const obtain = res?.data?.obtain;
        if (total) {
          setAverageMarksObtainedPercentage(Math.round((obtain / total) * 100));
        } else {
          setAverageMarksObtainedPercentage(0);
        }
      }).catch((error) => {
        setAverageMarksObtainedPercentage(0);
        console.log("Error fetching course marks:", error);
      });

      calculateAverageScoreActivities(selectedValue, relevantStudentId);
      calculateAverageScoreProject(selectedValue, relevantStudentId);
      calculatePointsEarned(selectedValue, relevantStudentId);
      handlePDF(selectedValue, relevantStudentId);
    }
  };

  return (
    <>

      {fullName && (
        <>
          {isAdmin && <AdminNav username={fullName} avatar={avatar} onLogout={onLogout} />}
          {isTeacher && <TeacherNav username={fullName} avatar={avatar} onLogout={onLogout} />}
          {isStudent && <StudentNav username={fullName} avatar={avatar} onLogout={onLogout} />}
        </>
      )}
      {!fullName && <>{isGuest && <GuestNav onLogin={onLogin} />}</>}
      <div className="main-layout">
        <div className="progress-page">
          <Header title="Student Progress" />

          <div className="progress-content">
            {/* Course Dropdown - Centered above progress cards */}
            <select
              name="course"
              id="course"
              className="coursesOption"
              value={selectedCourse}
              onChange={handleCourseChange}
              style={{ zIndex: 1000, position: "relative", display: "inline-block" }}
              disabled={filteredCourses.length === 0}
            >
              <option value="">Select Course</option>
              {filteredCourses.map((course) => (
                <option key={course?.Course_id} value={course?.Course_id}>
                  {course?.coursename}
                </option>
              ))}
            </select>
            <div className="course-title" style={{ textAlign: "center", }}>

              <h2>{studentName || "No student selected"}</h2>
            </div>

            {/* Progress Cards */}
            <div className="progress-cards-grid">
              <div className="progress-card">
                <div className="card-title-container">
                  <div className="card-icon certificate">
                    <img
                      src={certificateIcon || pic1}
                      alt="Certificate"
                      className="progress-image-icon"
                      onError={(e) => {
                        e.target.src = pic1;
                        e.target.onerror = null;
                      }}
                    />
                  </div>
                  <div className="card-title">Certificate</div>
                </div>
                <div className="card-content">
                  <div className="card-value">
                    {pdfUrl ? (
                      <a href={pdfUrl} target="_blank" rel="noopener noreferrer">
                        <span className="card-main-value">Available</span>
                        <span className="card-sub-value">Click to view</span>
                      </a>
                    ) : (
                      <span className="card-main-value">No</span>
                    )}
                  </div>
                </div>
              </div>

              <div className="progress-card">
                <div className="card-title-container">
                  <div className="card-icon activities">
                    <img
                      src={activitiesIcon || pic1}
                      alt="Activities"
                      className="progress-image-icon"
                      onError={(e) => {
                        e.target.src = pic1;
                        e.target.onerror = null;
                      }}
                    />
                  </div>
                  <div className="card-title">Avg. score Activities</div>
                </div>

                <div className="card-content">

                  <div className="card-value">
                    <span className="card-main-value">{averageMarksObtainedPercentage !== null ? `${averageMarksObtainedPercentage}%` : "—"}</span>
                  </div>
                </div>
              </div>

              <div className="progress-card">
                <div className="card-title-container">
                  <div className="card-icon">
                    <img
                      src={remarksIcon || pic1}
                      alt="Remarks"
                      className="progress-image-icon"
                      onError={(e) => {
                        e.target.src = pic1;
                        e.target.onerror = null;
                      }}
                    />
                  </div>
                  <div className="card-title">Remarks</div>
                </div>
                <div className="card-content">
                  <div className="card-value">
                    <span className="card-main-value">Good</span>
                  </div>
                </div>
              </div>

              <div className="progress-card">
                <div className="card-title-container">
                  <div className="card-icon project">
                    <img
                      src={projectIcon || pic1}
                      alt="Project"
                      className="progress-image-icon"
                      onError={(e) => {
                        e.target.src = pic1;
                        e.target.onerror = null;
                      }}
                    />
                  </div>
                  <div className="card-title">Avg. score Project</div>
                </div>
                <div className="card-content">
                  <div className="card-value">
                    {typeof averageProjectScorePercentage === "number" && !isNaN(averageProjectScorePercentage) ? (
                      <span className="card-main-value">{averageProjectScorePercentage.toFixed(1)}%</span>
                    ) : (
                      <>
                        <span className="card-main-value">—</span>
                        <span className="card-sub-value">No data</span>
                      </>
                    )}
                  </div>
                </div>
              </div>

              <div className="progress-card">
                <div className="card-title-container">
                  <div className="card-icon points">
                    <img
                      src={pointsIcon || pic1}
                      alt="Points"
                      className="progress-image-icon"
                      onError={(e) => {
                        e.target.src = pic1;
                        e.target.onerror = null;
                      }}
                    />
                  </div>
                  <div className="card-title">Points Earned</div>
                </div>
                <div className="card-content">
                  <div className="card-value">
                    <span className="card-main-value">{Math.round(totalPointsEarned) || 0}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default StudentProgress;